import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import CarDetails from '../components/cars/CarDetails';
import './CarDetails.css';
import './Home.css';
import '../components/cars/CarDetails.css';


const CarDetailsPage = () => {
  return (
    <div>
      <main className="cardetailspage">
        <CarDetails />
        
      </main>
    </div>
  );
};

export default CarDetailsPage;